export const WEBSITE = {
    DOMAIN: 'www.magazines24-7.com'
}